import { render, staticRenderFns } from "./Parcel.vue?vue&type=template&id=9f316bda"
import script from "./Parcel.vue?vue&type=script&lang=js"
export * from "./Parcel.vue?vue&type=script&lang=js"
import style0 from "./Parcel.vue?vue&type=style&index=0&id=9f316bda&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports